import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram } from "react-icons/fa";
import { CiLinkedin } from "react-icons/ci";
import { FaFacebookF } from "react-icons/fa6";
function FooterInitials() {
  return (
    <div className="flex gap-4 justify-center">
      <Link
        className="p-[4px] lg:p-[5px] bg-gray-900 text-white rounded-md"
        target="_blank"
        to={"https://www.instagram.com/kohlishreyash/"}
      >
        <FaInstagram fontSize={"1.1rem"} className="lg:text-2xl" />
      </Link>
      <Link
        className="p-[4px] lg:p-[5px] bg-gray-900 text-white rounded-md"
        to={"https://www.linkedin.com/in/shreyash-kumar-78026821a/"}
        target="_blank"
      >
        <CiLinkedin fontSize={"1.1rem"} className="lg:text-2xl" />
      </Link>
      <Link
        className="p-[4px] lg:p-[5px] bg-gray-900 text-white rounded-md"
        target="_blank"
        to={"https://www.facebook.com/shreyash.kumar.902"}
      >
        <FaFacebookF fontSize={"1.1rem"} className="lg:text-2xl" />
      </Link>
    </div>
  );
}

export default FooterInitials;
